module.exports = {
	"base": {
		"welcome": "ยินดีต้อนรับสู่ Mulligans, %{name}!",
		"user": "ข้อมูลผู้ใช้",
		"devices": "เครื่อง",
		"refunds": "การขอเงินคืน",
		"resources": "ข้อมูล",
		"transactions": "คำสั่งซื้อและการคืนสินค้า",
		"email": "อีเมล",
		"password": "รหัสผ่าน",
		"save": "บันทึก",
		"sign-out": "ลงชื่อออก",
		"cancel": "ยกเลิก",
		"close": "ปิด",
		"learn-more": "เรียนรู้เพิ่มเติม",
		"required": "จำเป็น",
		"support": "การสนับสนุน",
		"bookshelf": "Bookshelf",
		"launch": "เปิดใช้",
		"download": "ดาวน์โหลด",
		"details": "รายละเอียด",
		"cannot-be-blank": "%{field} ไม่สามารถเว้นว่างได้",
		"saving": "กำลังบันทึก...",
		"done": "เสร็จสิ้น",
		"failed": "ล้มเหลว",
		"copy": "คัดลอก"
	},
	"signin": {
		"login-failure": "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
		"welcome-large": "ยินดีต้อนรับสู่ <span class='inner'>ศูนย์ดูแลบัญชี %{brand}</span>",
		"welcome-small": "<span class='inner'>ศูนย์ดูแลบัญชี</span>",
		"signin-button": "ลงชื่อเข้าใช้",
		"forgot-password": "ลืมรหัสผ่าน",
		"new-to-vst": "เพิ่งเริ่มใช้ %{brand} ใช่ไหม",
		"create-account": "สร้างบัญชี",
		"signing-in": "กำลังลงชื่อเข้าใช้...",
		"signin-failed": "การลงชื่อเข้าใช้ล้มเหลว"
	},
	"transactions": {
		"price": "ราคา",
		"excluded": "(ไม่รวมภาษี)",
		"quantity": "จำนวน",
		"confirmation#": "หมายเลขการยืนยัน",
		"payment": "การชำระเงิน",
		"purchased": "รายการที่ซื้อแล้ว",
		"purchase-details": "รายละเอียดการซื้อ",
		"subtotal": "ยอดรวมย่อย",
		"total": "ยอดรวม",
		"tax": "ภาษี",
		"loading": "นี่ นักจ่ายมือเติบ เรากำลังโหลดธุรกรรมของคุณ...",
		"no-purchases": "คุณไม่มีรายการซื้อ",
		"seller-vat": "ภาษีมูลค่าเพิ่มสำหรับผู้ขาย",
		"total-vat": "ยอดรวมภาษีมูลค่าเพิ่มที่ชำระแล้ว %{vat}",
		"portion": "%{subTax} ภาษี %{rate}%",
		"vat-disclosure": "ราคารวมภาษีมูลค่าเพิ่ม %{vat}",
		"purchases": "รายการซื้อ",
		"refunded-items": "รายการที่ขอเงินคืน",
		"book-title": "ชื่อหนังสือ",
		"refund-details": "รายละเอียดการคืนเงิน",
		"print-receipt": "พิมพ์ใบเสร็จรับเงิน",
		"request-refund": "คำขอเงินคืน",
		"expired": "หมดอายุแล้ว",
		"expires-in": "หมดอายุ %{date}",
		"details-refund": "รายละเอียดและการคืนเงิน",
		"modal": {
			"cant-refund-title": "ไม่สามารถขอเงินคืนได้",
			"cant-refund": "ไม่สามารถขอเงินคืนค่าหนังสือของคุณได้เนื่องจากเหตุผลตั้งแต่หนึ่งข้อขึ้นไปดังต่อไปนี้",
			"cant-refund-1": "มีการดูหนังสือของคุณมากเกินไป",
			"cant-refund-2": "ผ่านมาแล้วเกิน 14 วันหลังจากวันที่ซื้อ",
			"cant-refund-3": "รหัสข้อมูลออนไลน์ของคุณถูกเปิดเผยแล้ว",
			"cant-refund-4": "หนังสือของคุณมีการขอเงินคืนก่อนหน้านี้แล้ว",
			"cant-refund-5": "รหัสทั้งหมดได้รับการลงทะเบียนใช้สิทธิและ/หรือคืนเงินแล้ว",
			"cant-refund-6": "ผ่านมาแล้วเกิน 30 วันหลังจากวันที่ซื้อ",
			"cant-refund-support": "หากคุณยังไม่แน่ใจเกี่ยวกับนโยบายการคืนเงินของ %{brand} โปรดติดต่อ <a href='%{support_url}' target='_blank'>ฝ่ายสนับสนุน</a>"
		},
		"license": {
			"perpetual": "การเข้าถึงทางออนไลน์ไม่มีการหมดอายุ",
			"days": "สิทธิ์เข้าถึง %{days} วัน"
		}
	},
	"devices": {
		"description": "%{brand} ช่วยให้คุณสามารถเปิดใช้งานคอมพิวเตอร์ <span>%{desktop}</span> และอุปกรณ์เคลื่อนที่/แท็บเล็ต <span>%{mobile}</span> ได้ทุกเมื่อตามเวลาที่กำหนด",
		"loading": "เฮย์ เรากำลังรับอุปกรณ์ของคุณ",
		"no-active": "คุณไม่มีอุปกรณ์ที่ใช้งาน",
		"deactivate": "ปิดใช้งาน"
	},
	"user": {
		"personal-information": "ข้อมูลส่วนตัว",
		"security-information": "ข้อมูลความปลอดภัย",
		"notifications": "การแจ้งเตือน",
		"first-name": "ชื่อ",
		"last-name": "นามสกุล",
		"change-password-title": "เปลี่ยนรหัสผ่าน",
		"current-password": "รหัสผ่านปัจจุบัน",
		"new-password": "รหัสผ่านใหม่",
		"security-password": "รหัสผ่าน",
		"confirm-new-password": "ยืนยันรหัสผ่านใหม่",
		"security-question": "คำถามรักษาความปลอดภัย",
		"security-info-change": "เปลี่ยน",
		"question": "คำถาม",
		"answer": "คำตอบ",
		"notifications-text": "ส่งอีเมลอัพเดทเกี่ยวกับกิจกรรมบัญชีของฉัน ผลิตภัณฑ์ใหม่ และข้อเสนอพิเศษถึงฉัน",
		"loading": "Spot กำลังออกไปดึงข้อมูลผู้ใช้ของคุณ รอแป๊บนะ 🐶",
		"change-password-text": "รหัสผ่านต้องมีความยาวอย่างน้อย 8 อักขระ มีตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก และอักขระพิเศษ",
		"email-locked": "อีเมลถูกล็อก",
		"email-locked-description": "คุณไม่ได้รับอนุญาตในการเข้าถึงเพื่อเปลี่ยนแปลงอีเมลของคุณ",
		"email-locked-more": "กรุณาติดต่อผู้ดูแลระบบของคุณ",
		"security-question6": "กีฬาโปรดของคุณคืออะไร",
		"security-question7": "ไอศครีมรสโปรดของคุณคืออะไร",
		"security-question8": "ชื่อของสัตว์เลี้ยงตัวโปรดของคุณคืออะไร",
		"security-question9": "ตอนคุณเป็นเด็ก คุณอยากเป็นอะไรเมื่อโตขึ้น",
		"security-question10": "นามสกุลของคุณครูคนโปรดของคุณคืออะไร",
		"new-password-failure": "รหัสผ่านไม่ตรงตามข้อกำหนด",
		"confirm-password-failure": "รหัสผ่านต้องตรงกัน",
		"new-password-tooltip": "ต้องมีความยาวอย่างน้อย 8 อักขระ มีตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก และอักขระพิเศษ",
		"enter-valid-email": "โปรดป้อนอีเมลที่ถูกต้อง",
		"password-cannot-be-same": "รหัสผ่านต้องไม่เหมือนกับรหัสผ่านเดิม",
		"incorrect-password": "รหัสผ่านไม่ถูกต้อง",
		"complete-account": "ดูเหมือนว่าคุณจะต้อง <a href='%{href}'>ดำเนินการบัญชีของคุณให้เสร็จสิ้น</a>",
		"completing-allows": "การดำเนินการบัญชีของคุณให้เสร็จสิ้นช่วยให้คุณสามารถอ่านหนังสือแบบออฟไลน์ได้ในแอปบนมือถือของเรา รวมถึงแชร์บันทึกและข้อความเน้นกับเพื่อนๆ",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "อุปกรณ์ประกอบ",
		"access-codes": "รหัสเข้าถึง",
		"print-on-demand": "พิมพ์ตามต้องการ",
		"check-pod": "ตรวจสอบตัวเลือกการพิมพ์ของผู้จัดพิมพ์หนังสือของคุณ",
		"check-now": "ตรวจสอบเดี๋ยวนี้",
		"loading": "รอก่อนนะ เรากำลังอัปเดตทรัพยากรของคุณ!",
		"in": "ใน",
		"access-code-intro": "รหัสเข้าถึงคือรหัสผ่านที่คุณใช้เข้าถึงเนื้อหาหลักสูตรออนไลน์ เมื่อคุณเปิดเผยรหัสสำหรับสินค้า คุณจะไม่สามารถคืนสินค้านั้นได้ สำหรับคำแนะนำเพิ่มเติมเกี่ยวกับการใช้รหัสเข้าถึงของคุณ โปรดไปที่ <a href='%{support_url}' target='_blank'>ฝ่ายสนับสนุน</a>",
		"expires": "หมดอายุ",
		"expiration-message": "จะมีคำแนะนำสำหรับการใช้รหัสเข้าถึงของคุณ",
		"copy-fail": "ไม่สามารถคัดลอกได้ โปรดเลือกรหัสแล้วคัดลอกด้วยตนเอง",
		"launch-site": "เปิดใช้งานไซต์",
		"launch-book": "เปิดใช้หนังสือ",
		"reveal-code": "เปิดรหัส",
		"no-resources": "คุณไม่มีทรัพยากร",
		"no-access-codes": "คุณไม่มีรหัสเข้าถึง",
		"no-ancillaries": "ไม่มีอุปกรณ์ประกอบสำหรับชื่อเรื่องนี้",
		"name": "ชื่อ",
		"type": "ประเภท",
		"size": "ขนาด",
		"download-all": "ดาวน์โหลดทั้งหมด",
		"back": "กลับไปยังแหล่งที่มา"
	},
	"refunds": {
		"states": {
			"refunded": "คืนเงินแล้ว",
			"unavailable": "ไม่สามารถขอคืนเงินได้"
		},
		"reasons": {
			"dropped": "ฉันเลิกเรียนหลักสูตรแล้ว",
			"wrong": "นี่ไม่ใช่หนังสือสำหรับหลักสูตรของฉัน",
			"print": "ฉันตัดสินใจซื้อหนังสือที่พิมพ์เป็นเล่มแทน",
			"missing": "หนังสือไม่ได้มีทุกอย่างที่ฉันต้องการสำหรับหลักสูตรของฉัน (เช่น CD การเข้าถึงเว็บ วิดีโอ)",
			"other": "อื่นๆ"
		},
		"bulk": {
			"policy": "ด้วยการคลิกที่ปุ่ม &quot;การขอเงินคืนเสร็จสมบูรณ์&quot; ด้านล่าง ฉันยอมรับ %{brand} สำหรับ <a href='%{policy_url}' target='_blank'>นโยบายการคืนเงิน</a>",
			"complete": "การขอเงินคืนเสร็จสมบูรณ์",
			"view-details": "ดูรายละเอียดการขอเงินคืน",
			"success": "ส่งคำขอการขอคืนเงินของคุณแล้ว โปรดรอ 48 ชั่วโมงสำหรับการดำเนินการ",
			"failure": "อุ๊บส์ มีบางอย่างผิดปกติ! ทำให้ขอเงินคืนไม่สำเร็จ",
			"retry": "ลองอีกครั้ง",
			"support": "ติดต่อฝ่ายสนับสนุน",
			"available-codes": "รหัสที่ใช้ได้",
			"codes-selected": "รหัสที่เลือก",
			"download": "ดาวน์โหลดรหัส",
			"partially-refunded": "คืนเงินบางส่วนแล้ว",
			"pick-one": "คุณต้องเลือกอย่างน้อยหนึ่งรหัสเพื่อดำเนินการขอเงินคืน"
		},
		"refund": "การขอเงินคืน",
		"all": "ขอเงินคืนทั้งหมดใช่หรือไม่",
		"missing-reason": "คุณต้องเลือกเหตุผลเพื่อดำเนินการต่อ",
		"missing-elaboration": "โปรดอธิบายโดยละเอียด",
		"policy": "ด้วยการคลิกที่ปุ่ม “คำขอเงินคืนเสร็จสมบูรณ์” ด้านล่าง ฉันเข้าใจว่าหากฉันซื้อeTextbook %{brand} อีกครั้ง ฉันจะไม่ได้รับสิทธิ์ในการขอเงินคืนเพิ่มเติมใดๆ อีกต่อไป สำหรับ eTextbook เล่มเดียวกัน ดูนโยบายการขอคืนเงินฉบับสมบูรณ์",
		"refunded": "คืนเงินแล้ว",
		"sorry": "เราเสียใจที่คุณไม่พอใจกับรายการซื้อของคุณ",
		"error": "มีบางอย่างผิดปกติ",
		"error-explain": "เราไม่สามารถดำเนินการคืนเงินของคุณได้ โปรดลองอีกครั้ง",
		"why": "ช่วยบอกเราหน่อยว่าเพราะอะไร",
		"no-refunds": "คุณไม่มีสินค้าที่ขอคืนเงิน",
		"select-codes": "เลือกรหัสเพื่อขอเงินคืน:",
		"number": "เท่าไหร่",
		"back": "กลับไปยังการคืนเงิน"
	},
	"purchases": {
		"back": "กลับไปยังการซื้อ"
	},
	"global-bar": {
		"account": "การตั้งค่าบัญชี"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/th.json
 ** module id = 1024
 ** module chunks = 0
 **/